import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var ArrowIcon = (props, _ref) => {
  var {
    attrs
  } = _ref;
  var _a, _b, _c, _d;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var {
    width,
    height,
    strokeColor,
    fillColor
  } = props;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.243 11.621",
    width: "".concat(width),
    height: "".concat(height),
    class: (_a = props.class) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, h("path", {
    fill: "none",
    stroke: "".concat((_c = attrs["stroke-color"]) !== null && _c !== void 0 ? _c : "#222"),
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "".concat((_d = attrs["stroke-width"]) !== null && _d !== void 0 ? _d : "3"),
    d: "m18.121 2.121-8 8-8-8"
  }));
};